import styled from '@emotion/styled-base';

export const Wrapper = styled(`div`)`
  .form__input {
    position: relative;
  }

  /*  .modal {
    display: block;
    background: rgba(0, 0, 0, 0.5);
  }*/

  .input-icon {
    font-size: 24px;
    cursor: pointer;
    color: lightgrey;
  }

  .icon-wrapper {
    top: 20%;
    right: 4px;
  }

  .icon--black {
    color: #000;
    font-weight: bold;
  }

  .switcher-wrap {
    position: relative;
    cursor: pointer;
  }

  .ball-text {
    position: absolute;
    top: 9%;
    z-index: 2;

    &.left {
      left: 4%;
      padding: 4px 5px 4px 9px;
    }

    &.right {
      right: 5%;
      padding: 4px 17px 4px 17px;
    }

    &.grey {
      color: var(--secondary);
    }

    &.white {
      color: var(--white);
    }
  }

  .groove {
    width: calc(5rem * 2);
    background-color: #7e57c2;
    padding: calc(1.5rem / 10);
    border-radius: 1.5rem;
    float: left;
  }

  .ball {
    width: 5rem;
    height: 1.8rem;
    background-color: #fff;
    border-radius: 1.8rem;

    &.to-right {
      transform: translateX(4.65rem);
      transition: transform 0.3s;
    }

    &.to-left {
      transform: translateX(0);
      transition: transform 0.3s;
    }
  }

  .input {
    padding: 5px 7px 5px 7px;
    width: 11%;
  }

  .input::-webkit-outer-spin-button,
  .input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .refresh {
    font-size: 24px;
    cursor: pointer;
  }

  .expirationDaysCalculated {
    margin-top: 4px;
    font-weight: 500;
  }

  .rotate {
    animation: rotate-animation 1s infinite linear;
  }

  @keyframes rotate-animation {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(-180deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }

  .limit__help-tooltip-wrapper {
    position: absolute;
    top: -20%;
    right: 46%;
  }

  .limit__help-tooltip {
    width: 500px;
  }

  .package-item {
    display: flex;
  }

  .modal-dialog {
    max-width: 60% !important;
  }

  .item-naming {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }

  .item-name {
    font-weight: 700;
    font-size: 14px;
  }

  .item-article {
    font-size: 12px;
  }

  .item-image {
    margin-top: 4px;
  }

  .main-header-block {
    background-color: #f1f5f7;
    padding: 16px;
    margin-bottom: 16px;

    h4 {
      margin: 0;
    }
  }

  .parameters {
    font-size: 16px;
    margin-top: 32px;
    margin-bottom: 32px;
    font-weight: 700;
  }

  padding-left: 0;
  padding-right: 0;
  font-size: 13px;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }
  .card-title {
    padding-top: 4px;
    padding-bottom: 13px;
  }
  .header-title {
    font-size: 16px;
  }
  .tip-wrap {
    position: relative;
    .tip-plus {
      height: 17px;
      width: 17px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #72747b;
      border-radius: 50%;
      margin-right: 5px;
      cursor: pointer;
    }
    .tip {
      position: absolute;
      left: -10px;
      top: -35px;
      background: white;
      border-radius: 2px;
      border: 1px solid #ebebeb;
      padding: 3px 7px;
      z-index: 1;
      &::before {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 10px;
        height: 10px;
        width: 10px;
        background: white;
        transform: rotate(45deg);
        z-index: 0;
      }
    }
  }
  .packing-video-block {
    margin-top: -2px;
    margin-left: auto;
    display: flex;
    i {
      font-size: 20px;
      margin-right: 10px;
    }
    a {
      display: block;
      color: #4fc6e1;
      text-decoration: underline;
    }
  }
  .packings-wrapper form {
    > div {
      padding: 12px;
      background: #f6f8f9;
      border: 1px solid #e0e9ee;
      box-sizing: border-box;
      border-radius: 4px;
      color: #72747b;
      margin-bottom: 12px;
      &:last-child {
        margin-bottom: 0;
      }
      .parameters {
        margin-top: 4px;
      }
      .pallet-weight,
      .packing-quantity {
        min-width: 81px;
        display: flex;
        justify-content: flex-end;
        font-weight: 500;
      }
      .pallet-item,
      .packing-item {
        margin-top: 10px;
        &:first-child {
          margin-top: 2px;
        }
      }
      .packing-top {
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        justify-content: space-between;

        .pallet-barcode {
          margin-top: 13px;
          font-weight: 500;
          margin-right: 24px;
        }

        .show-packing-info-button {
          display: flex;
          align-items: center;
          margin-top: 12px;
          cursor: pointer;
          font-weight: 500;
          i {
            font-size: 20px;
            margin-left: 4px;
            cursor: pointer;
          }
        }
      }
      .packing-items {
        margin-top: 12px;
        border-top: 1px solid #ebebeb;
        padding-top: 12px;
        > div {
          display: flex;
        }
      }
    }
    .show-packing-info-button {
      display: flex;
      align-items: center;
      cursor: pointer;
      font-weight: 500;
      i {
        font-size: 20px;
        margin-left: 4px;
        cursor: pointer;
      }
    }
  }

  .packing-item {
    justify-content: space-between;
    flex-wrap: wrap;
    @media (max-width: 1500px) and (min-width: 1300px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 1200px) and (min-width: 1025px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
    @media (max-width: 500px) {
      flex-direction: column;
      .packing-item-right {
        flex-direction: column;
        .packing-quantity {
          margin-left: 0;
          width: auto;
          justify-content: flex-start;
        }
      }
    }
  }

  .pallet-item {
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
  }

  .pallet-item-barcode {
    margin-top: 4px;
    margin-right: 15px;
  }

  .packing-item-name {
    margin-right: 15px;
    font-weight: 500;
    margin-bottom: 2px;
    max-width: 450px;
    @media (max-width: 1610px) {
      max-width: 300px;
    }
    @media (max-width: 1500px) {
      max-width: 250px;
    }
  }

  .packing-item-right {
    display: flex;
  }

  .packing-item-left {
    display: flex;
  }

  .packing-quantity {
    margin-left: 24px;
  }

  .packing-main {
    margin-top: 48px;

    > div:last-child {
      .show-packing-info-button {
        margin-top: 12px;
      }
      .pallet-barcode {
        margin-top: 13px;
      }
    }
  }

  .packing-right {
    display: flex;
    .pallet-barcode {
      display: flex;
      align-items: center;
    }
  }

  .packing-item-string {
    display: flex;

    p {
      max-width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 -13px 0 0;
      transition: 0.15s;
    }

    .fe-copy {
      align-self: center;
      cursor: pointer;
      opacity: 0;
      transition: 0.15s;
    }

    &:hover {
      p {
        max-width: calc(100% - 21px);
        margin: 0 8px 0 0;
      }

      .fe-copy {
        opacity: 1;
      }
    }
  }

  .equipment-headergroup {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 800px) {
      align-items: start;
      flex-direction: column;
    }
    .equipment-headerblock {
      display: flex;
      align-items: center;
      @media (max-width: 800px) {
        align-items: start;
        flex-direction: column;
      }
      button {
        margin-left: 8px;
      }
      .header-title {
        margin-right: 8px;
      }
      .ti-download {
        margin-right: 10px;
      }
    }

    .header-title {
      margin: 0;
    }
  }
`;
